import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCredentials, setLicence, sideMenuState, useGetUserLicenceMutation } from './authSlice';
import { isApprover } from '../users/creation/assets/utills';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const ForceLogin = () => {
    const dispatch = useDispatch();
      const [userLicense] =
        useGetUserLicenceMutation();
          const nav = useNavigate();
    useEffect(async () => {
        // Retrieve the URL parameters
        const params = new URLSearchParams(window.location.search);
    
        // Get the 'param' parameter from the URL
        const param = params.get('param');
    
      
          try {
            // Parse the 'param' parameter (assuming it's JSON encoded)
        // Parse the decoded parameter
        const parsedData = JSON.parse(param);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/backoffice/auth/force/log-in`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${parsedData?.token}`, // Add token to Authorization header
              },
              body: JSON.stringify({ accountId:parsedData?.accountId }), // Send accountId in the request body
            });

            if (!response.ok) {
              toast.error(response?.message || 'Only developer can access this resource');
            }

             const responseData = await response.json();
             dispatch(setCredentials(responseData));
             dispatch(sideMenuState(false));
              userLicense()
                         .then((license) => {
                           if (license?.data) {
                             dispatch(setLicence({ licence: license }));
                             window.location.href =
                               license?.data?.accepted === 1
                                 ? isApprover(responseData?.account)
                                   ? '/approvers'
                                   : '/dashboard'
                                 : 'privacy-policy';
                           } else nav(`/logout`);
                         })
                         .catch((error) => nav(`/logout`));
          } catch (apiError) {
          }
        
           

          } catch (error) {
            console.error('Failed to parse param:', error);
          }
        
      }, []);
      return (
        <div>
          <h1>Login...</h1>
        </div>
      );
};
